import { Button } from '@/components/button/button'
import { Card, CardContent } from '@/components/card/card'

import { cn } from '@/lib/utils'

import { useUpdateCaseInfoDialogStore } from '../stores/use-update-case-info-dialog-store'

export const CaseProcessingTimeErrorBoundary = () => {
  const { openDialog: openUpdateCaseInfoDialog } = useUpdateCaseInfoDialogStore()

  return (
    <Card>
      <CardContent className={cn('px-4')}>
        <div
          className={cn('rounded-[9px]', 'bg-secondary', 'px-4 pb-3 pt-2.5', 'mt-6', 'text-xs font-normal leading-6')}
        >
          Data unavailable on USCIS. Please make sure the case information is correct.
        </div>
        <div className={cn('mt-3')}>
          <Button variant="outline" size="sm" onClick={() => openUpdateCaseInfoDialog()}>
            Update Case Info
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
